import type z from 'zod';

import { paginationSchema } from '@schemas/pagination.schema';

export const getAllBusinessLinesSchema = paginationSchema;

export type GetAllBusinessLinesParams = z.infer<
  typeof getAllBusinessLinesSchema
>;
